import React from "react";
import { useNavigate } from "react-router-dom";

function PersonalProfile(props) {
  const item = props.item;
  const navigate = useNavigate();
  const navigateTo = () => {
    if (item?.socialLinks) {
      window.open(item?.socialLinks, "_blank");
    }
  };
  return (
    <div className="personal-tab">
      <div className="bio">
        <div className="set-title">Bio</div>
        <div className="option-text">{item?.exp || item?.bioDescription}</div>
      </div>
      <div className="bio">
        <div className="set-title">languages can speak</div>
        <div className="options">
          <div className="skill-set">
            {item?.languages?.split(",")?.map((item, index) => {
              return <div className="skill subTitle">{item}</div>;
            })}
          </div>
        </div>
      </div>
      {item?.socialLinks && (
        <div className="bio">
          <div className="set-title">Social links</div>
          <div className="options">
            <div className="skill-set">
              <div
                onClick={
                  () => navigateTo()
                  // window.open(item?.socialLinks?.replace(/^"|"$/g, ""), '_blank')
                }
                className="skill subTitle"
              >
                Linkedin
              </div>
              {/* {["Linkedin"].map((item, index) => {
                return (
                  <div
                    onClick={
                      () => navigateTo()
                      // window.open(item?.socialLinks?.replace(/^"|"$/g, ""), '_blank')
                    }
                    className="skill subTitle"
                  >
                    {item}
                  </div>
                );
              })} */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default PersonalProfile;
